import GuideHero from '../../components/guides/GuideHero';
import GuideCTA from '../../components/guides/GuideCTA';
import FlyTypeSection from '../../components/guides/FlyTypeSection';

const flyTypes = [
  {
    number: 1,
    title: 'Dry Flies (Surface)',
    purpose: "Imitate adult insects floating on the water's surface",
    whenToUse: 'When you see fish rising or insects on the water',
    howTheyWork: 'Designed to float using buoyant materials like deer hair, elk hair, or specialized hackle',
    image: 'https://customer-assets.emergentagent.com/job_angler-connect/artifacts/t3mwgkmw_dry%20flies%202.jpg',
    alt: 'Collection of dry flies',
    features: ['Lightweight hooks', 'Buoyant materials (deer hair, elk hair)', 'Wings or posts for floatation', 'Palmered hackle for surface tension'],
    proTip: 'Dry flies work exceptionally well during summer evenings on lakes and during mayfly hatches on streams across North America.',
  },
  {
    number: 2,
    title: 'Nymphs & Wet Flies (Subsurface)',
    purpose: 'Imitate juvenile insects living underwater',
    whenToUse: "Most of the time - 80% of a trout's diet is underwater",
    howTheyWork: 'Designed to sink and drift naturally with the current',
    image: 'https://customer-assets.emergentagent.com/job_angler-connect/artifacts/0a9f7dvv_nymphs%20and%20wet%20flies.jpg',
    alt: 'Collection of nymphs and wet flies',
    features: ['Heavier hooks and materials', 'Often weighted with beads or wire', 'Natural, buggy appearance', 'Fished in a "dead drift"'],
    proTip: 'Nymphs are deadly in freestone rivers and Great Lakes tributaries where stoneflies and mayfly nymphs are abundant.',
  },
  {
    number: 3,
    title: 'Emergers (Surface Film)',
    purpose: 'Imitate insects transitioning from underwater to surface',
    whenToUse: 'During active hatches when insects are struggling to break through the surface',
    howTheyWork: 'Lightweight patterns that hang in the surface film',
    image: 'https://customer-assets.emergentagent.com/job_angler-connect/artifacts/hsbmz2eq_Emergers.jpg',
    alt: 'Collection of emergers',
    features: ['Lightweight construction', 'Designed for surface film fishing', 'Often have trailing shucks', 'Partially submerged appearance'],
    proTip: 'Emergers are particularly effective during Blue Winged Olive hatches on technical spring creeks and tailwaters.',
  },
  {
    number: 4,
    title: 'Streamers (Active Retrieve)',
    purpose: 'Imitate baitfish, minnows, leeches, and crayfish',
    whenToUse: 'For larger fish, in deeper water, or when covering lots of water',
    howTheyWork: 'Fished with motion and retrieve to trigger predatory strikes',
    image: 'https://customer-assets.emergentagent.com/job_angler-connect/artifacts/axcyi4sm_streamers.png',
    alt: 'Collection of streamers',
    features: ['Larger size (2-6 inches)', 'Mobile materials (marabou, rabbit fur)', 'Often weighted for depth', 'Fished with active retrieve'],
    proTip: 'Streamers are excellent for targeting large brook trout in wilderness areas and lake trout in northern lakes.',
  },
];

const FlyTypes = () => (
  <div className="min-h-screen bg-[#0F1419]">
    <GuideHero
      title="The 4 Essential Types of Flies"
      description="Every fly fishing fly falls into one of these four categories. Understanding their purpose and when to use them is fundamental to successful fly fishing."
    />

    <section className="py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {flyTypes.map((ft) => <FlyTypeSection key={ft.number} {...ft} />)}
      </div>
    </section>

    <GuideCTA
      title="Master These 4 Categories"
      description="Understanding when and how to use each type of fly is the foundation of successful fly fishing. The FlyFinder app takes this knowledge and applies it to your specific location and current conditions, recommending the right fly type and specific patterns for your exact fishing situation."
    />
  </div>
);

export default FlyTypes;
